import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Button } from '@chakra-ui/react';

import Link from '@repo/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

function PressCard({ title, date, description, link }) {
  const { tt, localizeDate } = useUiComponentsInternationalContext();

  return (
    <Flex
      flexDir="column"
      p={8}
      gap={6}
      bg="neutral.light"
      borderRadius="3xl"
      h="full"
    >
      <Text as="h2" textStyle="h2">
        {title}
      </Text>
      <Text textStyle="bodyLarge" flex={1}>
        <b>
          {localizeDate(date)} {date && description && '-'}
        </b>{' '}
        {description}
      </Text>

      <Button as={Link} link={`/press/${link}`}>
        {tt(s => s.pressCardComponent.readMoreButton)}
      </Button>
    </Flex>
  );
}

PressCard.defaultProps = {
  description: '',
};

PressCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  link: PropTypes.string.isRequired,
};

export default PressCard;
